'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

import React, { useCallback } from 'react';

import { IconBigArrowLeft } from '@/app/_componentsv2/icons/big-arrow-left';
import { IconBigArrowRight } from '@/app/_componentsv2/icons/big-arrow-right';
import { ApiSummaryProject } from '@/lib/core-api/types';

import { navigation, projectCarousel, projectSlides } from './index.css';
import { ProjectCard } from './project-card';

export function Carousel(props: { projects: ApiSummaryProject[] }) {
  const { projects } = props;

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false }, [
    WheelGesturesPlugin(),
  ]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) {
      emblaApi.scrollPrev();
    }
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) {
      emblaApi.scrollNext();
    }
  }, [emblaApi]);

  return (
    <>
      <section className={projectCarousel} ref={emblaRef}>
        <section className={projectSlides}>
          {projects.map((project) => (
            <ProjectCard key={project.slug} project={project} />
          ))}
        </section>
      </section>
      <section className={navigation}>
        <button onClick={scrollPrev}>
          <IconBigArrowLeft />
        </button>
        <button onClick={scrollNext}>
          <IconBigArrowRight />
        </button>
      </section>
    </>
  );
}
